// **** import modules ****
import app, { csl, vuwer } from "@@assets/scripts/common";

// **** process ****ｓ
app.gaAutoSendPageview = false;

app.onReady(async (...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	
	delete app._GET.sheet;
	app.replaceState(app._GET);
	
	if(app.device[0] === "sp") {
		vuwer.$window.on("beforeunload", e => {
			if(app.fm.getActiveSheet().name !== "finish") {
				return "このサイトを離れますか？（入力したデータは保存されません）";
			}
		});
	}
});

app.exec();